import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { cloneDeep, isEmpty, isObject, find } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "SingleOptionArgument",
  props: {
    items: {
      type: Array,
      required: true
    },
    placeholder: {
      type: String,
      default: ""
    },
    value: {
      type: Array,
      default: () => []
    },
    board: {
      type: Array,
      default: () => []
    }
  },
  data() {
    const localValue = isObject(this.value) ? [] : this.value;
    return {
      localValue
    };
  },
  computed: {
    currentText() {
      if (isEmpty(this.localValue)) {
        return this.placeholder || this.$t("automations.selectItems");
      } else {
        return this.localValue[0].name;
      }
    },
    boardId() {
      const [{
        boardId
      }] = this.items;
      return boardId;
    },
    options() {
      var _context;
      if (!this.boardId) return this.items;
      const boards = this.board || [];
      const selectedBoards = _mapInstanceProperty(boards).call(boards, ({
        value
      }) => value);
      return _filterInstanceProperty(_context = this.items).call(_context, item => _includesInstanceProperty(selectedBoards).call(selectedBoards, item.boardId));
    }
  },
  watch: {
    value(newValue) {
      this.localValue = newValue;
    },
    options() {
      this.localValue = [];
    },
    localValue() {
      this.$emit("input", this.localValue);
    }
  },
  beforeDestroy() {
    this.$emit("input", []);
  },
  methods: {
    select(item) {
      if (this.localValue.length && item.name === this.localValue[0].name) {
        this.localValue = [];
      } else {
        this.localValue = [cloneDeep(item)];
      }
    },
    isSelected(item) {
      const found = find(this.localValue, ({
        value
      }) => value === item.value);
      return !!found;
    }
  }
});